/** 音楽画面で共通に使う表示フォーマット関数 */

import { parseUtcDate } from '@/lib/date-utils'

/** ISO日時を「2007年3月7日」形式にする（未設定なら空文字） */
export const formatReleaseDate = (releasedAt: string | null): string => {
  if (!releasedAt) return ''
  const date = parseUtcDate(releasedAt)
  if (Number.isNaN(date.getTime())) return ''
  return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`
}

/** ISO日時を「2007年」形式にする（未設定なら空文字） */
export const formatReleaseYear = (releasedAt: string | null): string => {
  if (!releasedAt) return ''
  const date = parseUtcDate(releasedAt)
  if (Number.isNaN(date.getTime())) return ''
  return `${date.getFullYear()}年`
}

/** 合計秒数を「35分」形式にする（1時間以上は「1時間5分」） */
export const formatTotalDuration = (seconds: number): string => {
  const minutes = Math.round(seconds / 60)
  if (minutes < 60) return `${minutes}分`
  return `${Math.floor(minutes / 60)}時間${minutes % 60}分`
}
